import { Toast } from 'task-eva-ui'
import { Header } from '../header/header'
import { ShareLayout, Content } from './atom'
import { Outlet } from 'react-router-dom'
import { useToastStore } from '@/store/toast/toast-store'

export function Layout() {
  const getToastProps = useToastStore((state) => state.getToastProps())
  const { updateGlobalToast } = useToastStore()
  return (
    <ShareLayout>
      <Header />
      <Content>
        <Outlet />
      </Content>
      <Toast {...getToastProps} setShow={updateGlobalToast} />
    </ShareLayout>
  )
}
